<template>
  <div>
    <div id="VMCKeyVisual" class="carousel slide carousel-fade" data-ride="carousel">
      <div class="container">
        <ol class="carousel-indicators">
          <li data-target="#VMCKeyVisual" data-slide-to="0" class="active"></li>
          <li data-target="#VMCKeyVisual" data-slide-to="1"></li>
          <li data-target="#VMCKeyVisual" data-slide-to="2"></li>
          <li data-target="#VMCKeyVisual" data-slide-to="3"></li>
          <li data-target="#VMCKeyVisual" data-slide-to="4"></li>
          <li data-target="#VMCKeyVisual" data-slide-to="5"></li>
        </ol>
      </div>
      <div class="carousel-inner">
        <div class="carousel-item active parallax-effect" 
             :style="{backgroundImage: (cms.keyVisuals && cms.keyVisuals.slide1) ? 'url('+cms.keyVisuals.slide1+')' : 'url('+banner12+')'}" 
             id="BannerTwelve">
          <svg class="bd-placeholder-img" style="opacity: 55%" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" preserveAspectRatio="xMidYMid slice" focusable="false">
            <rect width="100%" height="100%" fill="var(--vmc-primary-3)"/>
          </svg>
          <div class="container">
            <div class="carousel-caption text-left">
              <p class="mb-2 font-weight-normal text-white caption-one">{{ cms.captionOneP1 }}</p> <!-- CMS controlled -->
              <p class="vmc-text-white font-weight-normal mb-0 caption-two">{{ cms.captionTwoP1 }}</p> <!-- CMS controlled -->
              <p class="vmc-text-white font-weight-light caption-three">{{ cms.captionThreeP1 }}</p> <!-- CMS controlled -->
            </div>
          </div>
        </div>
<!--        <div class="carousel-item parallax-effect" :style="{backgroundImage:'url('+banner11+')'}" id="BannerEleven">-->
<!--          <svg class="bd-placeholder-img" style="opacity: 55%" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" preserveAspectRatio="xMidYMid slice" focusable="false">-->
<!--            <rect width="100%" height="100%" fill="var(&#45;&#45;vmc-primary-3)"/>-->
<!--          </svg>-->
<!--          <div class="container">-->
<!--            <div class="carousel-caption text-left">-->
<!--              <p class="mb-2 font-weight-normal text-white caption-one"></p>-->
<!--              <p class="vmc-text-white font-weight-normal mb-0 caption-two"></p>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
        <div class="carousel-item parallax-effect" 
             :style="{backgroundImage: (cms.keyVisuals && cms.keyVisuals.slide2) ? 'url('+cms.keyVisuals.slide2+')' : 'url('+banner10+')'}" 
             id="BannerTen">
          <svg class="bd-placeholder-img" style="opacity: 55%" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" preserveAspectRatio="xMidYMid slice" focusable="false">
            <rect width="100%" height="100%" fill="var(--vmc-primary-3)"/>
          </svg>
          <div class="container">
            <div class="carousel-caption text-left">
              <p class="mb-2 font-weight-normal text-white caption-one">{{ cms.captionOneP2 }}</p> <!-- CMS controlled -->
              <p class="vmc-text-white font-weight-normal mb-0 caption-two">{{ cms.captionTwoP2 }}</p> <!-- CMS controlled -->
              <p class="vmc-text-white font-weight-light caption-three">{{ cms.captionThreeP2 }}</p> <!-- CMS controlled -->
            </div>
          </div>
        </div>
        <div class="carousel-item parallax-effect" 
             :style="{backgroundImage: (cms.keyVisuals && cms.keyVisuals.slide3) ? 'url('+cms.keyVisuals.slide3+')' : 'url('+banner9+')'}" 
             id="BannerNine">
          <svg class="bd-placeholder-img" style="opacity: 55%" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" preserveAspectRatio="xMidYMid slice" focusable="false">
            <rect width="100%" height="100%" fill="var(--vmc-primary-3)"/>
          </svg>
          <div class="container">
            <div class="carousel-caption text-left">
              <p class="mb-2 font-weight-normal text-white caption-one">{{ cms.captionOneP3 }}</p> <!-- CMS controlled -->
              <p class="vmc-text-white font-weight-normal mb-0 caption-two">{{ cms.captionTwoP3 }}</p> <!-- CMS controlled -->
              <p class="vmc-text-white font-weight-light caption-three">{{ cms.captionThreeP3 }}</p> <!-- CMS controlled -->
            </div>
          </div>
        </div>
        <div class="carousel-item parallax-effect" 
             :style="{backgroundImage: (cms.keyVisuals && cms.keyVisuals.slide4) ? 'url('+cms.keyVisuals.slide4+')' : 'url('+banner5+')'}" 
             id="BannerFive">
          <svg class="bd-placeholder-img" style="opacity: 55%" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" preserveAspectRatio="xMidYMid slice" focusable="false">
            <rect width="100%" height="100%" fill="var(--vmc-primary-3)"/>
          </svg>
          <div class="container">
            <div class="carousel-caption text-left">
              <p class="mb-2 font-weight-normal text-white caption-one">{{ cms.captionOneP4 }}</p> <!-- CMS controlled -->
              <p class="vmc-text-white font-weight-normal mb-0 caption-two">{{ cms.captionTwoP4 }}</p> <!-- CMS controlled -->
              <p class="vmc-text-white font-weight-light caption-three">{{ cms.captionThreeP4 }}</p> <!-- CMS controlled -->
            </div>
          </div>
        </div>
        <div class="carousel-item parallax-effect" 
             :style="{backgroundImage: (cms.keyVisuals && cms.keyVisuals.slide5) ? 'url('+cms.keyVisuals.slide5+')' : 'url('+banner6+')'}" 
             id="BannerSix">
          <svg class="bd-placeholder-img" style="opacity: 55%" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" preserveAspectRatio="xMidYMid slice" focusable="false">
            <rect width="100%" height="100%" fill="var(--vmc-primary-3)"/>
          </svg>
          <div class="container">
            <div class="carousel-caption text-left">
              <p class="mb-2 font-weight-normal text-white caption-one">{{ cms.captionOneP5 }}</p> <!-- CMS controlled -->
              <p class="vmc-text-white font-weight-normal mb-0 caption-two">{{ cms.captionTwoP5 }}</p> <!-- CMS controlled -->
              <p class="vmc-text-white font-weight-light caption-three">{{ cms.captionThreeP5 }}</p> <!-- CMS controlled -->
            </div>
          </div>
        </div>
        <div class="carousel-item parallax-effect" 
          :style="{backgroundImage: (cms.keyVisuals && cms.keyVisuals.slide6) ? 'url('+cms.keyVisuals.slide6+')' : 'url('+banner1+')'}" 
          id="BannerOne">
          <svg class="bd-placeholder-img" style="opacity: 55%" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" preserveAspectRatio="xMidYMid slice" focusable="false">
            <rect width="100%" height="100%" fill="var(--vmc-primary-3)"/>
          </svg>
          <div class="container">
            <div class="carousel-caption text-left">
              <p class="mb-2 font-weight-normal text-white caption-one">{{ cms.captionOneP6 }}</p> <!-- CMS controlled -->
              <p class="vmc-text-white font-weight-normal mb-0 caption-two">{{ cms.captionTwoP6 }}</p> <!-- CMS controlled -->
              <p class="vmc-text-white font-weight-light caption-three">{{ cms.captionThreeP6 }}</p> <!-- CMS controlled -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container bg-white">
      <div class="row py-3 d-flex align-items-center justify-content-center">
        <div class="col-auto p-1">
          <router-link class="btn vmc-btn-circle vmc-btn-secondary kv-low-btn" :to="{name: 'GovernmentAdvisories'}">
            ADVISORIES
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import { cmsMixin } from '@/mixins/cmsMixin'; // Import the CMS mixin (copy and paste this line)

export default {
  name: "KeyVisual",
  
  mixins: [cmsMixin], // Include the CMS mixin here (copy and paste this line)

  // Use data function to define your images
  data() {
    return {
      'banner1': require(`@/assets/no_image.jpg`),
      'banner5': require(`@/assets/no_image.jpg`),
      'banner6': require(`@/assets/no_image.jpg`),
      'banner9': require(`@/assets/no_image.jpg`),
      'banner10': require(`@/assets/no_image.jpg`),
      'banner12': require(`@/assets/no_image.jpg`)
    }
  },
  mounted() {
    const w = window.innerWidth;
    const h = window.innerHeight;
    const carousel1 = document.getElementById('BannerOne');
    const carousel4 = document.getElementById('BannerFive');
    const carousel5 = document.getElementById('BannerSix');
    const carousel8 = document.getElementById('BannerNine');
    const carousel9 = document.getElementById('BannerTen');
    const carousel11 = document.getElementById('BannerTwelve');

    if (w > 992 && w < h) {
      if (carousel1) carousel1.style.height = "60vh";
      if (carousel4) carousel4.style.height = "60vh";
      if (carousel5) carousel5.style.height = "60vh";
      if (carousel8) carousel8.style.height = "60vh";
      if (carousel9) carousel9.style.height = "60vh";
      if (carousel11) carousel11.style.height = "60vh";
    }

  }
}
</script>


<style scoped>
/* CUSTOMIZE THE CAROUSEL
-------------------------------------------------- */

/* Since positioning the image, we need to help out the caption */
.carousel-caption {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: auto;
  padding-right: 2rem;
  left: auto;
  right: auto;
  z-index: 10;
  text-shadow: 1px 3px 6px rgba(0, 0, 0, .5);
}
.carousel-indicators {
  border-radius: 100px;
  bottom: 5%;
  margin: auto;
  left: auto;
  right: auto;
  justify-content: start;
}
.carousel-indicators li {
  width: 10px;
  height: 10px;
  border-radius: 100%;
}
/* Declare heights because of positioning of img element */
.carousel-inner {
  overflow: hidden;
}
.carousel-item {
  height: calc(100vh - 100px);
  background-color: var(--vmc-primary-3);
}
.carousel-item > img {
  position: absolute;
  top: 0;
  left: 0;
  min-width: 100%;
  height: 32rem;
}

.parallax-effect {
  /* Stretch the background image to fill the entire slide */
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.kv-low-btn {
  width: 200px;
}
#VMCKeyVisual {
  margin-top: 85px;
}
.caption-one {
  letter-spacing: 3px;
  font-size: 14px;
}
.caption-two {
  font-size:40px;
  font-weight: 500;
  letter-spacing: 1px;
}
.caption-three {
  font-size: 16px;
}
@media (min-width: 40em) {
  /* Bump up size of carousel content */
  .carousel-caption {
    width: 100%;
  }
  .carousel-caption p {
    width: 100%;
    margin-bottom: 1.25rem;
    line-height: 1.4;
  }
}
@media (min-width: 576px) {
  #VMCKeyVisual {
    margin-top: 135px;
  }
  .carousel-indicators {
    bottom: 20%;
  }
  .carousel-caption {
    max-width: 500px;
  }
  .caption-one {
    letter-spacing: 3px;
    font-size: 14px;
  }
  .caption-two {
    font-size:50px;
    font-weight: 500;
    letter-spacing: 1px;
  }
  .caption-three {
    font-size: 21px;
  }
}

@media (min-width: 768px) {
  #VMCKeyVisual {
    margin-top: 85px;
  }
  .carousel-indicators {
    bottom: 20%;
  }
  .carousel-caption {
    max-width: 680px;
  }
  .caption-one {
    letter-spacing: 3px;
    font-size: 16px;
  }
  .caption-two {
    font-size:55px;
    font-weight: 500;
    letter-spacing: 1px;
  }
  .caption-three {
    font-size: 23px;
  }
}

@media (min-width: 992px) {
  #VMCKeyVisual {
    margin-top: 105px;
  }
  .carousel-indicators {
    bottom: 20%;
  }
  .carousel-caption {
    max-width: 940px;
  }
}

@media (min-width: 1200px) {
  #VMCKeyVisual {
    margin-top: 105px;
  }
  .carousel-indicators {
    bottom: 20%;
  }
  .carousel-caption {
    max-width: 1140px;
  }
}
</style>